import apiClient from "./ApiClient";
import { getEmployees } from "./GmsEmployee";

export const processEmployeeCredits = async (employeeId, adjustedBalances = {}) => {
  try {
    const response = await apiClient.post(`/api/AnnualLeaveCreditHistory/process/${employeeId}`, adjustedBalances);
    return response.data;
  } catch (error) {
    console.error("Error processing employee credits:", error);
    throw error;
  }
};

export const getEmployeeCreditHistory = async (employeeId) => {
  try {
    const response = await apiClient.get(`/api/AnnualLeaveCreditHistory/employee/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee credit history:", error);
    throw error;
  }
};

export const hasAutomaticCreditingStarted = async (employeeId) => {
  try {
    const response = await apiClient.get(`/api/AnnualLeaveCreditHistory/checkAutomaticCrediting/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error checking automatic crediting status:", error);
    throw error;
  }
};

export const saveAnnualLeaveCreditHistory = async (creditHistory) => {
  try {
    const response = await apiClient.post(`/api/AnnualLeaveCreditHistory/save`, creditHistory);
    return response.data;
  } catch (error) {
    console.error("Error saving annual leave credit history:", error);
    throw error;
  }
};

export const getEmployeesDueForLeaveCredit = async (employeeId = null) => {
  try {
    const params = employeeId ? `?employeeId=${employeeId}` : '';
    const response = await apiClient.get(`/api/AnnualLeaveCreditHistory/dueForLeaveCredit${params}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching employees due for leave credit:", error);
    throw error;
  }
};

// Get employees due for leave credit for notifications
export const getEmployeesDueForLeaveCreditNotification = async () => {
  try {
    // Get user's companyId and branchId from localStorage
    const userCompanyId = localStorage.getItem("userCompanyId");
    const userBranchId = localStorage.getItem("userBranchId");
    
    // Build filter object - only include if values exist
    const filter = {};
    if (userCompanyId && userCompanyId !== 'null' && userCompanyId !== 'undefined') {
      filter.employee_Business_Id = parseInt(userCompanyId);
    }
    if (userBranchId && userBranchId !== 'null' && userBranchId !== 'undefined') {
      filter.employee_Branch_Id = parseInt(userBranchId);
    }
    
    const employees = await getEmployeesDueForLeaveCredit();
    const allEmployees = await getEmployees(filter);
    
    const dueEmployees = [];
    
    employees.forEach(employee => {
      if (employee.days_Overdue > 0) {
        // Find employee details from the filtered employee list
        const employeeDetails = allEmployees.find(emp => emp.employee_Id === employee.employee_Id);
        
        // Only include if employee exists in filtered list (matches company/branch filter)
        if (employeeDetails) {
          dueEmployees.push({
            employeeId: employee.employee_Id,
            employeeName: employeeDetails.employee_NameEn || employeeDetails.employee_Name || 'Unknown',
            employeeCode: employeeDetails.employee_Code || 'N/A',
            lastCreditDate: new Date(employee.last_Credit_Date),
            daysOverdue: employee.days_Overdue,
            isCritical: employee.days_Overdue >= 30 // Critical if overdue by 30+ days
          });
        }
      }
    });
    
    // Sort by urgency (critical first, then by days overdue)
    dueEmployees.sort((a, b) => {
      if (a.isCritical && !b.isCritical) return -1;
      if (!a.isCritical && b.isCritical) return 1;
      return b.daysOverdue - a.daysOverdue; // Higher overdue days first
    });
    
    return dueEmployees;
  } catch (error) {
    console.error("Error fetching employees due for leave credit notification:", error);
    return [];
  }
}; 